/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack, StackDivider} from '@salesforce/retail-react-app/app/components/shared/ui'
import useUpdateResetPasswordFields from '@consteed/overrides/components/forms/useUpdateResetPasswordFields'
import Field from '@consteed/overrides/components/field'
import PasswordRequirements from '@salesforce/retail-react-app/app/components/forms/password-requirements'

const UpdateResetPasswordFields = ({form, prefix = ''}) => {
    const fields = useUpdateResetPasswordFields({form, prefix})
    const password = form.watch('password')

    return (
        <Stack spacing={5} divider={<StackDivider borderColor="gray.100" />}>
            <Stack>
                <Field {...fields.token} />
            </Stack>

            <Stack spacing={3} pb={2}>
                <Field {...fields.password} />
                <PasswordRequirements value={password} />
            </Stack>
        </Stack>
    )
}

UpdateResetPasswordFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default UpdateResetPasswordFields
